
import "./Membership.scss";

export default function Membership() {
  
  
  return (
    <div className="login">
      <div className="top">
        <div className="wrapper">
          <img
            className="logo"
            src="https://metrowancore.nextwarela.com/media/images/logo.png"
            alt=""
          />
        </div>
      </div>
      <div className="container">
        <form>
          <h1>No cuenta con una membresía activa</h1>
          <span>
            Comuniquese con soporte support@nextwarela.com
          </span>
         
        </form>
        
      </div>
    </div>
  );
}